"use client"

import { useState } from "react"
import { ZoomIn } from "lucide-react"
import "./product-details.css"

export default function ImageGallery({ images, variant }) {
  const [selectedImage, setSelectedImage] = useState(0)
  const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 })
  const [showZoom, setShowZoom] = useState(false)
  // const [touchStart, setTouchStart] = useState({ x: 0, y: 0 })
  const handleMouseMove = (e) => {
    if (!showZoom) return

    const { left, top, width, height } = e.currentTarget.getBoundingClientRect()
    const x = ((e.clientX - left) / width) * 100
    const y = ((e.clientY - top) / height) * 100

    setZoomPosition({ x, y })
  }

  // const handleTouchStart = (e) => {
  //   const touch = e.touches[0]
  //   setTouchStart({ x: touch.clientX, y: touch.clientY })
  // }

  const handleTouchMove = (e) => {
    if (!showZoom) return

    const touch = e.touches[0]
    const { left, top, width, height } = e.currentTarget.getBoundingClientRect()
    const x = ((touch.clientX - left) / width) * 100
    const y = ((touch.clientY - top) / height) * 100

    setZoomPosition({ x, y })
  }

  return (
    <div className="product_details_gallery_container">
      {/* Main Image with Zoom */}
      <div className="product_details_main_image_container">
        <div
          className="product_details_main_image_wrapper"
          onMouseEnter={() => setShowZoom(true)}
          onMouseLeave={() => setShowZoom(false)}
          onMouseMove={handleMouseMove}
          // onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={() => setShowZoom(false)}
        >
          <img
            src={images[selectedImage] || "/placeholder.svg"}
            alt={`${variant} chocolate - view ${selectedImage + 1}`}
            className="product_details_main_image"
            style={{ width: '75%', height: 'auto' }}
          />

          {/* Zoom indicator for mobile */}
          <div className="product_details_zoom_indicator">
            <ZoomIn className="product_details_zoom_icon" />
          </div>

          {/* Zoom overlay */}
          {showZoom && (
            <div
              className="product_details_zoom_overlay"
              style={{
                backgroundImage: `url(${images[selectedImage]})`,
                backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
                backgroundSize: "200%",
                backgroundRepeat: "no-repeat",
              }}
            />
          )}
        </div>
      </div>

      {/* Thumbnails */}
      <div className="product_details_thumbnails_container">
        {images.map((img, index) => (
          <button
            key={index}
            className={`product_details_thumbnail_btn ${
              selectedImage === index ? "product_details_thumbnail_selected" : ""
            }`}
            onClick={() => setSelectedImage(index)}
          >
            <img
              src={img || "/placeholder.svg"}
              alt={`Thumbnail ${index + 1}`}
              className="product_details_thumbnail_img"
            />
          </button>
        ))}
      </div>
    </div>
  )
}